import treatmentReportsService from '../../../services/treatmentReportsService';
import { getFranchiseeId } from '../services/reportHelpers';
import useConfirm from '../../../hooks/useConfirm';

export const useReportActions = (userProfile, notifications, dataHelpers) => {
  const { showNotification } = notifications;
  const { reloadCurrentPage } = dataHelpers;
  const { confirmDialog, confirm } = useConfirm();

  // Handle report deletion
  const handleDeleteReport = async (reportId, reportNumber) => {
    const ok = await confirm({
      title: 'Delete Treatment Report',
      message: `Permanently delete treatment report ${reportNumber}?`,
      variant: 'danger',
      confirmLabel: 'Delete'
    });
    if (!ok) return;

    const franchiseeId = getFranchiseeId(userProfile);
    if (!franchiseeId) return;

    try {
      await treatmentReportsService.deleteTreatmentReport(franchiseeId, reportId);
      showNotification('Treatment report deleted successfully');
      reloadCurrentPage();
    } catch (error) {
      console.error('Error deleting treatment report:', error);
      showNotification('Failed to delete treatment report', 'error');
    }
  };

  // Handle PDF generation
  const handleGeneratePDF = async (reportId, reportNumber) => {
    const franchiseeId = getFranchiseeId(userProfile);
    if (!franchiseeId) return;

    try {
      const response = await treatmentReportsService.generatePDF(franchiseeId, reportId);
      if (response.pdf_url) {
        showNotification(`PDF generated for report ${reportNumber}`);
      }
    } catch (error) {
      console.error('Error generating PDF:', error);
      showNotification('Failed to generate PDF', 'error');
    }
  };

  return {
    handleDeleteReport,
    handleGeneratePDF,
    confirmDialog
  };
};
